import { apiUrl, apiHeaders } from "./apiConfig";
// Submits a website form to our own API. The server builds and sends every
// email (recipients, subjects, content); nothing about email is decided here.
//
// Returns { success, message } so callers can show the result.
export const submitLead = async (form, data) => {
  try {
    const res = await fetch(apiUrl("/api/lead"), {
      method: "POST",
      headers: apiHeaders,
      body: JSON.stringify({ form, ...data }),
    });
    const response = await res.json().catch(() => null);
    if (!response) {
      // Non-JSON reply: the API server is down or restarting
      return {
        success: false,
        message: "We couldn’t reach our server. Please try again in a moment.",
      };
    }
    return {
      success: res.ok && response.success,
      message: response.message || "Failed to send email. Please try again.",
    };
  } catch (error) {
    return {
      success: false,
      message: "We couldn’t reach our server. Please try again in a moment.",
    };
  }
};
